module.exports = __webpack_public_path__ + "media/images/linkedin_white-db20e40f5c7d00c53208e06546758b89.png";